import { useContext, useEffect, useState } from 'react';
import { EditContext } from '../context/EditContext';

export function useSiteConfig() {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const { configVersion } = useContext(EditContext);
  useEffect(() => {
    let ok = true;
    fetch('/api/config')
      .then((r) => r.json())
      .then((d) => { if (ok) { setConfig(d || {}); setLoading(false); } })
      .catch(() => { if (ok) setLoading(false); });
    return () => { ok = false; };
  }, [configVersion]);
  return { config, loading };
}
